import React, { FC, ReactElement } from "react";
import style from "./style.scss";
import { ThemeBuilderSectionLine } from "./ThemeBuilderSectionLine";
import { WidgetValuePicker, WidgetValuePickerChildrenProps, WidgetValuePickerProps } from "./WidgetValuePicker";
import { Input } from "@xapp/components";

export interface WidgetColorPickerProps extends Pick<WidgetValuePickerProps<string>, "overrideLabel" | "defaultLabel" | "passBackDefault"> {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly disabled?: boolean;
    readonly headingContent?: ReactElement;
    onChange(value: string): void;
}

export const WidgetColorPickerRaw: FC<WidgetValuePickerChildrenProps<string>> = props => {
    return (
        <Input
            className={style.colorPickerValue}
            type="color"
            value={props.value || ""}
            disabled={props.override || props.disabled}
            onChange={(value) => props.onChange(value as string)}
        />
    );
};

const WidgetColorPickerInner: FC<WidgetColorPickerProps> = props => {
    return (
        <ThemeBuilderSectionLine label={props.label ?? "Color"} headingContent={props.headingContent}>
            <WidgetValuePicker<string>
                value={props.value}
                defaultValue={props.defaultValue}
                children={WidgetColorPickerRaw}
                disabled={props.disabled}
                onChange={props.onChange}
                overrideLabel={props.overrideLabel}
                defaultLabel={props.defaultLabel}
                passBackDefault={props.passBackDefault}
            />
        </ThemeBuilderSectionLine>
    );
};

export const WidgetColorPicker = React.memo(WidgetColorPickerInner);
